<template>
	<div class="wrapper" :style="position">
		<div class="card border border-1 w-100 h-100">

			<div class="card-inner">
				<div class="inner-border p-1">
					<span class="legend">
						{{ $t(label) }}
					</span>

					<div class="card-content">
						<div class="d-flex">
							<div v-for="(value,index) in values" :key="index" class="col">
								<span
									:class="{ 'text-danger': value == subvalues[selected], 'text-secondary': value != subvalues[selected] }"
									v-html="t(value)"
									@click="selected = subvalues.indexOf(value)"
									style="cursor: pointer;">
								</span>
								<div class="label-line"></div>
							</div>
						</div>

						<div class="mx-auto" :style="sliderWidth">
							<input type="range" class="form-range" min="0" :max="steps-1" v-model.number="selected">
							<div v-if="steps != values.length" style="position: relative; margin: auto; width: calc(100% - 16px); height: 1em;">
								<span class="position-absolute text-danger" style="transform: translate(-50%, 0%)" :style="sliderThumbText">
									{{ subvalues[selected] }}
								</span>
							</div>
						</div>

						<div v-if="$te(values[0] + '_text')" class="mt-3">
							{{ $t(values[selected] + "_text") }}
						</div>

						<div v-if="$te(values[0] + '_info')" class="mt-3 text-white" :style="sliderTextStyle">
							<span v-html="$t(values[selected] + '_info')"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
// import Component from '@/components/Component.vue';

export default {
	props: [ "sliderId", "label", "values", "subvalues", "steps", "slots", "pos", "boxWidth", "boxHeight" ],
	components: {},
	data() {
		return {
			selected: 0,
		};
	},
	computed: {
		position() {
			return {
				left: `${this.x}%`,
				top: `${this.y}%`,
				transform: `translate(-50%, -50%)`,
				width: `${this.boxWidth}%`,
				height: `${this.boxHeight}%`,
			};
		},
		sliderWidth() {
			return {
				position: "relative",
				width: `calc(${100*(1-1/this.values.length)}% + 16px)`,
			};
		},
		sliderThumbText() {
			return {
				left: 100 * (this.selected / (this.steps-1)) + "%",
			};
		},
		sliderTextStyle() {
			if (this.sliderId == "greenhouse_effect_slider") {
				return {
					position: "absolute",
					width: "100%",
					left: "12%",
					top: "-250%",
					lineHeight: "2em",
					fontSize: "1.25em",
				};
			}
			else if (this.sliderId == "scenario_indicator_slider") {
				return {
					position: "absolute",
					width: "100%",
					left: "12%",
					top: "-320%",
					lineHeight: "1.7em",
					fontSize: "1.2em",
				};
			}
			else {
				return {
					display: "none",
				};
			}
		},

		rect() {
			return this.$refs.card.getBoundingClientRect();
		},
		x() {
			return this.pos.x;
		},
		y() {
			return this.pos.y;
		},
		width() {
			return this.rect.width * this.widthRatio;
			// return this.$refs.card.offsetWidth;
		},
		height() {
			return this.rect.height * this.heightRatio;
			// return this.$refs.card.offsetHeight;
		},
	},
	watch: {
		selected() {
			this.$emit('onChange', this.selected, this.subvalues[this.selected]);
			this.$log.onSliderChange(this.sliderId, this.selected, this.subvalues[this.selected]);
		}
	},
	mounted() {
		this.$emit('onChange', this.selected, this.subvalues[this.selected]);
	}
};
</script>



<style scoped>
	.wrapper {
		position: absolute;
	}


	.card {
		border: 2px solid rgba(255, 255, 255, 1.0);
		border-radius: 0.4em;

		background-size: contain;
		background-position: center;

		line-height: 1em;
		text-align: left;
		justify-content: flex-end;

		transition: all .06s ease;
	}

	.card-inner {
		height: 100%;
		display: flex;
		flex: 1 1 auto;
		padding: 1.0rem 0.4rem 0.4rem;
	}

	.legend {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translate(-50%, -50%);
		background: white;
		color: gray;
		padding: 0 1em;
		white-space: nowrap;
	}

	.inner-border {
		position: relative;
		width: 100%;
		height: 100%;
		border: 1px solid gray;
		border-radius: 6px;
		padding: 1em;
		display: flex;
	}

	.card-content {
		display: flex;
		text-align: center;
		flex-direction: column;
		margin: auto;
		width: 100%;
		max-height: 100%;
		overflow-y: auto;
		padding: 2px;
	}

	/*input[type=range]::-moz-range-thumb {
		background: var(--bs-danger);
		width: 16px;
	}*/
	input[type=range]::-moz-range-thumb {
		background: var(--bs-danger);
		width: 16px;
	}
	input[type=range]::-ms-thumb {
		background: var(--bs-danger);
		width: 16px;
	}
	input[type=range]::-webkit-slider-thumb {
		background: var(--bs-danger);
		width: 16px;
	}

	.label-line {
		width: 0px;
		height: 1em;
		border-right: 1px solid var(--bs-gray-700);
		margin: auto;
		margin-bottom: -0.7em;
	}
</style>
